export const SAVE_EAD_STARTED = "SAVE_EAD_STARTED";
export const SAVE_EAD_SUCCESS = "SAVE_EAD_SUCCESS";
export const SAVE_EAD_FAILED = "SAVE_EAD_FAILED";

export const GET_EADPETITION_STARTED = "GET_EADPETITION_STARTED";
export const GET_EADPETITION_SUCCESS = "GET_EADPETITION_SUCCESS";
export const GET_EADPETITION_FAILED = "GET_EADPETITION_FAILED";

export const CREATE_EADPETITION_STARTED = "CREATE_EADPETITION_STARTED";
export const CREATE_EADPETITION_SUCCESS = "CREATE_EADPETITION_SUCCESS";
export const CREATE_EADPETITION_FAILED = "CREATE_EADPETITION_FAILED";

export const UPDATE_EADPETITION_STARTED = "UPDATE_EADPETITION_STARTED";
export const UPDATE_EADPETITION_SUCCESS = "UPDATE_EADPETITION_SUCCESS";
export const UPDATE_EADPETITION_FAILED = "UPDATE_EADPETITION_FAILED";

export const SAVE_EADFORMSUBMIT_STARTED = "SAVE_EADFORMSUBMIT_STARTED";
export const SAVE_EADFORMSUBMIT_SUCCESS = "SAVE_EADFORMSUBMIT_SUCCESS";
export const SAVE_EADFORMSUBMIT_FAILED = "SAVE_EADFORMSUBMIT_FAILED";

export interface IVisaCareEADCase {
    status: {
        statusCode: number,
        statusDisplay: string,
        statusValue: boolean
    };
    items: Array<any>;
    edaCaseCreateInput: {
        insert_datetime:Date,
        inserted_by:string,
        update_datetime:Date,
        updated_by:string
       
    };
    permission_id: number;
    isLoading: boolean;
    error: string;
}
export const saveEAD = (input: any) => {
   
    return {
        type: SAVE_EAD_STARTED,
        payload: 'status',
        input: input
    };
};
export const getEADPetition = (caseId,petitionDetailsType) => {
 
    return {
        type: GET_EADPETITION_STARTED,
        payload: 'status',
        input: caseId,
        inputParam: petitionDetailsType
    };
};

export const createEADPetition = (eadInput: any) => {
 
    return {
        type: CREATE_EADPETITION_STARTED,
        payload: 'status',
        input: eadInput
    };
};

export const updateEADPetition = (eadInput: any) => {
 
    return {
        type: UPDATE_EADPETITION_STARTED,
        payload: 'status',
        input: eadInput
    };
};


export const eadPdfFormSubmit = (caseId: any) => {
 
    return {
        type: SAVE_EADFORMSUBMIT_STARTED,
        payload: 'status',
        input: caseId
    };
};
 